import { pubSub } from '@utils/PubSub';
export default class PromoBanner {
  constructor(context) {
    this.moduleEl = context;
    const expiration = window.Brooklinen.dyExpiration ?? 5000;
    pubSub.subscribe('dy:promoBanner:init', () => {
      this.initBanner();
    });
    // Show backup if DY doesn't load
    setTimeout(() => {
      this.showDefault();
    }, expiration);
  }

  async initBanner() {
    if (window?.Brooklinen?.promoBanner) {
      const promoBannerDY = window?.Brooklinen.promoBanner;
      const matchedModuleObj = promoBannerDY.find(
        (module) => module.general.id == this.moduleEl.dataset.dyId
      );
      if (matchedModuleObj) {
        await this.updateModule(matchedModuleObj);
      } else this.showDefault();
    }
  }

  showDefault() {
    const promoBannerModule = document.querySelectorAll('.js-promo-banner');
    promoBannerModule.forEach((banner) => {
      banner.classList.add('fade-in');
      banner.style.opacity = 1;
    });
  }

  updateSettings(obj) {
    const { moduleEl } = this,
      { dataset } = moduleEl,
      { textColor, backgroundHexColor } = obj.general;

    // Update colors and fonts
    if (backgroundHexColor !== '')
      moduleEl.style.backgroundColor = backgroundHexColor;
    if (textColor !== '') moduleEl.dataset.color = textColor;
    // Update Data
    dataset.metaSrc = 'dy';
    this.updatePadding(obj);
  }

  updatePadding(obj) {
    const { moduleEl } = this;
    let paddingClass = '';
    if (obj?.copy?.subcopy?.desktop != '') {
      paddingClass = ['padding-32-35'];
    } else if (obj?.copy?.headline?.style == 'h3') {
      paddingClass = ['padding-24', 'padding-24-40'];
    } else if (obj?.copy?.headline?.style == 'h4') {
      paddingClass = ['padding-24'];
    }
    moduleEl.classList.add(...paddingClass);
  }

  updatePromoBannerPosition(beforeHero) {
    const { moduleEl } = this;
    if (
      beforeHero == 'false' &&
      moduleEl.classList.contains('module--promo-banner-homepage')
    ) {
      moduleEl.classList.add('hp-hero--after');
    } else if (
      beforeHero == 'true' &&
      moduleEl.classList.contains('module--promo-banner-homepage')
    ) {
      document
        .querySelector('#primaryHero')
        .classList.add('promo-banner--before');
    }
  }
  updateContent(obj) {
    const { moduleEl } = this,
      { headline, subcopy, button } = obj.copy,
      containerEl = moduleEl.querySelector('.BannerContainer'),
      copyContainer = moduleEl.querySelector('.BannerContainer__Copy'),
      headlineEl = moduleEl.querySelector('.BannerContainer__Headline'),
      headlineDesktopEl = headlineEl.querySelector('.BannerContainer__Desktop'),
      headlineMobileEl = headlineEl.querySelector('.BannerContainer__Mobile'),
      subcopyEl = moduleEl.querySelector('.BannerContainer__Sub'),
      subcopyDesktopEl = subcopyEl.querySelector('.BannerContainer__Desktop'),
      subcopyMobileEl = subcopyEl.querySelector('.BannerContainer__Mobile'),
      buttonWrapperEl = moduleEl.querySelector('.BannerContainer__CTA'),
      buttonEl = buttonWrapperEl.querySelector('a');
    // Update headline
    if (headline.desktop !== '') headlineDesktopEl.innerHTML = headline.desktop;
    if (headline.mobile !== '') headlineMobileEl.innerHTML = headline.mobile;
    headlineEl.classList.remove('h3', 'h4');
    headlineEl.classList.add(headline.style);
    // Update subcopy. This field is optional, so we can't check to see if it's
    // not empty to update.
    if (subcopy.desktop !== '' && button.copy !== '') {
      containerEl.classList.remove('BannerContainer--Partial');
      copyContainer.classList.remove('BannerContainer--Partial__Copy');
      containerEl.classList.add('BannerContainer--Full');
      copyContainer.classList.add('BannerContainer--Full__Copy');
    } else {
      containerEl.classList.remove('BannerContainer--Full');
      copyContainer.classList.remove('BannerContainer--Full__Copy');
      containerEl.classList.add('BannerContainer--Partial');
      copyContainer.classList.add('BannerContainer--Partial__Copy');
    }

    subcopyDesktopEl.innerHTML = subcopy.desktop;
    subcopyMobileEl.innerHTML = subcopy.mobile;

    // Enable or disable the element as needed.
    if (subcopy.desktop !== '' || subcopy.mobile !== '') {
      subcopyEl.classList.remove('disabled');
    } else {
      subcopyEl.classList.add('disabled');
    }

    buttonWrapperEl.classList.remove(
      'button--tertiary-a',
      'button--tertiary-b',
      'button--tertiary-a-inverse'
    );
    // Add all this to accomodate the DY swap of templates that have the old classes
    if (button.style === 'button--primary') {
      buttonWrapperEl.classList.add('button--tertiary-b');
    } else if (button.style === 'button--secondary') {
      buttonWrapperEl.classList.add('button--tertiary-a');
    } else if (
      button.style === 'button--primary--white' ||
      button.style === 'button--secondary--white'
    ) {
      buttonWrapperEl.classList.add('button--tertiary-b-inverse');
    } else {
      buttonWrapperEl.classList.add(button.style);
    }

    buttonEl.innerHTML = button.copy;
    buttonEl.href = button.link;

    // Enable or disable the element as needed.
    if (button.copy !== '' || button.link !== '') {
      buttonWrapperEl.classList.remove('disabled');
    } else {
      buttonWrapperEl.classList.add('disabled');
    }
  }

  removeAttributes(element) {
    while (element.attributes.length > 0) {
      element.removeAttribute(element.attributes[0].name);
    }
  }

  setAttributes(element, attributes) {
    Object.keys(attributes).forEach((attr) => {
      element.setAttribute(attr, attributes[attr]);
    });
  }

  async updateModule(obj) {
    const { moduleEl } = this;
    this.updateSettings(obj);
    this.updateContent(obj);
    // Show DY content
    moduleEl.classList.add('fade-in');
    moduleEl.style.opacity = 1;

    this.updatePromoBannerPosition(obj?.general?.bannerPosition);
    return true;
  }
}
